

const ALLOWED_EXTS = new Set([
  'csv', 'xls', 'xlsx',
  'pdf',
  'png', 'jpeg', 'jpg', 'webp',
  'docx', 'pptx',
  'json', 'txt',
  'heic',
  'svg', 'txt'
]);

export function extOf(name = '') {
  const idx = name.lastIndexOf('.');
  if (idx < 0) return '';
  return name.slice(idx + 1).toLowerCase();
}

export function isSupportedFileExt(ext = '') {
  return ALLOWED_EXTS.has((ext || '').toLowerCase());
}